import React from "react";
import {LeftOutlined} from "@ant-design/icons";
import {Col, Layout, Row} from "antd";

import {BuildSidebarLinks} from "../routes/buildRoutes";
import {getLogo} from "../helpers/misc";

const logo = getLogo();
const {Sider} = Layout;

// width values
const desktopWidth = '200px';
const mobileWidth = '100%';
const desktopCollapsedWidth = 80;
const mobileCollapsedWidth = 0;

interface EngageSideBarProps {
    sideMenuCollapsed: boolean;
    mobileMode: boolean;
    toggleSideMenu: () => void;
    isStaff: boolean;
    isBusiness: boolean;
    hasMembership: boolean;
}

const EngageSidebar = ({
    sideMenuCollapsed,
    mobileMode,
    toggleSideMenu,
    isStaff,
    isBusiness,
    hasMembership,
}: EngageSideBarProps) => {
    //region side menu Collapsed state
    const [collapsed, setCollapsed] = React.useState(false);
    const onCollapse = (collapsed: boolean) => {
        setCollapsed(collapsed);
    };

    // Toggle collapsed state based on trigger and hamburger icon click.
    React.useEffect(() => {
        setCollapsed(sideMenuCollapsed);
    }, [sideMenuCollapsed]);

    // Collapse side menu after clicking on link in mobile mode.
    const handleLinkClickedMobile = () => {
        if (mobileMode) {
            setCollapsed(true);
            toggleSideMenu();
        }
    };
    //endregion

    //region side menu width and collapsed width
    const [width, setWidth] = React.useState(desktopWidth);
    const [collapsedWidth, setCollapsedWidth] = React.useState(desktopCollapsedWidth);
    React.useEffect(() => {
        if (mobileMode) {
            setCollapsed(true);
            setCollapsedWidth(mobileCollapsedWidth);
            setWidth(mobileWidth);
        } else {
            setCollapsedWidth(desktopCollapsedWidth);
            setWidth(desktopWidth);
        }
    }, [mobileMode]);
    //endregion

    return (
        <Sider
            collapsible
            width={width}
            collapsedWidth={collapsedWidth}
            collapsed={collapsed}
            onCollapse={onCollapse}
            breakpoint="lg"
            style={{
                overflow: 'auto',
                height: '100vh',
                left: 0,
            }}
        >
            <Row style={{'backgroundColor': '#fff', 'lineHeight': '64px'}}>
                <Col xs={4} md={24}>
                    <div className="sidebar-logo-container">
                        <img src={logo} className="sidebar-logo" alt="logo"/>
                    </div>
                </Col>
                <Col xs={16} md={0}/>
                <Col xs={4} md={0}>
                    <div
                        className="sider-trigger-container"
                        onClick={toggleSideMenu}
                    >
                        <LeftOutlined
                            className="trigger"
                            style={{'fontSize': '24px', 'cursor': 'pointer'}}
                        />
                    </div>
                </Col>
            </Row>
                <BuildSidebarLinks
                    menuReduced={collapsed}
                    menuCollapsed={sideMenuCollapsed}
                    handleMobileLinkClicked={handleLinkClickedMobile}
                    isStaff={isStaff}
                    isBusiness={isBusiness}
                    hasMembership={hasMembership}
                />
        </Sider>
    );
}

export default EngageSidebar;
